import { render, staticRenderFns } from "./ClicksIcon.vue?vue&type=template&id=04a3ab6f&"
import script from "./ClicksIcon.vue?vue&type=script&lang=js&"
export * from "./ClicksIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports